import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#242424",
      d: "m2.42 12.174.91-5.82 1.042 7.11h-.937c-.611 0-1.126-.59-1.016-1.29Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#242424",
      "fill-rule": "evenodd",
      d: "M4.626 2.537c-.391 0-.73.365-.661.846l1.446 10.08h8.417c.292 0 .558-.273.504-.652l-1.374-9.585c-.059-.41-.393-.689-.739-.689H4.626Zm2.438 1.115h3.15c.408 0 .74.349.74.78v.006c0 .43-.332.78-.74.78h-3.15c-.41 0-.741-.35-.741-.78v-.007c0-.43.332-.779.741-.779Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }